/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarnumber_Drie3Inputs */

const nl_enums_leerjaarnumber_drie3 = /** @type {(inputs: Enums_Leerjaarnumber_Drie3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3`)
};

/**

* @param {Enums_Leerjaarnumber_Drie3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarnumber_drie3 = /** @type {((inputs?: Enums_Leerjaarnumber_Drie3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarnumber_Drie3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarnumber_drie3(inputs)
});
export { enums_leerjaarnumber_drie3 as "enums.LeerjaarNumber.Drie" }